<template src="./template.html"></template>
<script>
import moment from 'moment'
import { mapState } from 'vuex'

import eventService from 'api/event'
import urlUtils from 'utils/urlUtils'
import iframeLib from 'lib/iframe'
import InventoryList from 'components/InventoryList'
import InventoryMap from 'components/InventoryMap'
import ReadMore from 'components/ReadMore'
import dateUtils from 'utils/dateUtils'
import TRACKING_EVENTS from 'constants/trackingEvents'
import analyticsLib from 'lib/analytics'

export default {
  name: 'event-detail',
  props: {
    disableScroll: {
      type: Boolean,
      default: false,
    },
    eventId: {
      type: String,
      required: true,
    },
    eventObj: {
      type: Object,
      required: false,
    },
    buttonText: {
      type: String,
      default: 'View Event',
    },
    buttonBgColor: {
      type: String,
    },
    buttonTextColor: {
      type: String,
    },
    textColor: {
      type: String,
    },
    theme: {
      type: String,
      default: 'theme-light',
    },
  },
  components: {
    InventoryList,
    InventoryMap,
    ReadMore,
  },
  computed: {
    ...mapState({
      date: (state) => state.date.current,
      venue: (state) => state.venue.current,
      inventory: (state) => state.inventory.current,
    }),
    eventHasPassed() {
      if (!this.event) return true

      let now = moment()

      if (now.hours() < 6) now.subtract(1, 'day')

      now = now.startOf('day')

      const eventDate = moment(this.event.dateStart)

      return eventDate.isBefore(now)
    },
    soundcloudUrl() {
      if (!this.event || !this.event.details || !this.event.details.soundcloud) {
        return ''
      }

      return `https://w.soundcloud.com/player/?url=${this.event.details.soundcloud}&amp;color=0066cc`
    },
  },
  data() {
    return {
      previewEventFlyer: false,
      event: null,
      loading: false,
      eventNotFound: false,
    }
  },
  methods: {
    goToMapsUrl() {
      const address = (this.event.venue.location || {}).address || {}

      if (!address.address) return

      let baseUrl = 'https://www.google.com/maps/dir//'

      if (address.address) baseUrl += `+${address.address.replace(/ /g, '+')},`
      if (address.city) baseUrl += `+${address.city.replace(/ /g, '+')},`
      if (address.state) baseUrl += `+${address.state.replace(/ /g, '+')}`
      if (address.zip) baseUrl += `+${address.zip}`

      window.open(baseUrl)
    },
    showPreviewEventFlyer() {
      this.previewEventFlyer = true
    },
    hidePreviewEventFlyer() {
      this.previewEventFlyer = false
    },
    getImageUrl() {
      if (!this.event || !this.event.primaryImage || !this.event.primaryImage.filename) return ''

      return urlUtils.optimizedImageUrl(this.event.primaryImage.filename, {
        width: 400,
      })
    },
    getUpcomingImageUrl(event) {
      if (!event || !event.primaryImage || !event.primaryImage.filename) return ''

      return urlUtils.optimizedImageUrl(event.primaryImage.filename, {
        width: 100,
        height: 100,
      })
    },
    imgLoaded() {
      this.$emit('updated')
    },
    dimensiondUpdated() {
      this.$emit('updated')
    },
    getEvent() {
      return eventService
        .getById(this.eventId, {
          fields: ['venue()'].join(','),
        })
        .then((event) => {
          this.event = event
        })
        .catch(() => {
          this.eventNotFound = true
        })
    },
    onUpdated() {
      this.$emit('updated')
    },
    onInventoryListUpdated() {
      this.$emit('updated')
    },
    onInventoryMapUpdated() {
      this.$emit('updated')
    },
    scrollWindow() {
      const modalWindowEl = document.querySelector('.modal-scroll')

      if (this.disableScroll) {
        return
      }

      if (!iframeLib.inIframe()) {
        window.scroll({
          top: (this.$el.querySelector('.event-detail-content') || {}).offsetTop,
          left: 0,
          behavior: 'smooth',
        })
      } else if (modalWindowEl) {
        //NOTE: if we're in a modal we can just scroll the modal element

        if (window.innerWidth <= 770) {
          modalWindowEl.scroll({
            top: 1300,
            left: 0,
            behavior: 'smooth',
          })
        } else {
          modalWindowEl.scroll({
            top: 40,
            left: 0,
            behavior: 'smooth',
          })
        }
      } else {
        //NOTE: but if the widget isn't in a modal we need the outer widget script to scroll the outer page

        this.$emit('scrollTop')
      }
    },
    onInventorySectionClicked(data) {
      if (!data) throw new Error('data is required')
      if (!data.layoutSection) return

      this.scrollWindow()

      this.$refs.inventoryList.selectSection(data.layoutSection)
    },
    onInventoryMouseover(inventory) {
      if (this.$refs.inventoryMap) {
        this.$refs.inventoryMap.unhighlightAllTables()
      }

      if (inventory.venueLayoutSection && this.$refs.inventoryMap) {
        this.$refs.inventoryMap.highlightTablesByLayoutSectionId(inventory.venueLayoutSection)
      }
    },
    onFloorplanLoaded() {
      this.$emit('updated')
    },
    onInventoryMouseleave(inventory) {
      if (inventory.venueLayoutSection && this.$refs.inventoryMap) {
        this.$refs.inventoryMap.unhighlightTablesByLayoutSectionId(inventory.venueLayoutSection)
      }
    },
    //tracking
    trackViewedEvent() {
      return analyticsLib.trackEvent(TRACKING_EVENTS.ViewedEvent, {
        venueId: this.venue.id,
        venueName: this.venue.name,
        eventId: this.event.id,
        eventName: this.event.name,
      })
    },
  },
  created() {
    this.loading = true

    if (this.eventObj) {
      this.event = this.eventObj
    }

    (this.eventObj ? Promise.resolve(this.eventObj) : this.getEvent())
      .then(() => {
        this.$store.dispatch('setCurrentVenue', this.event.venue)

        let date = moment.utc(this.event.date, 'x')
        date = dateUtils.toUTCMomentWithoutTime(date)

        this.$store.dispatch('setCurrentDate', date)

        this.loading = false

        return this.trackViewedEvent()
      })
      .catch((error) => {
        this.loading = false

        if (error.message === 'event not found') {
          this.eventNotFound = true
        }
      })
  },
  updated() {
    this.$emit('updated')
  },
}
</script>



// WEBPACK FOOTER //
// src/components/EventDetail/index.vue